import { FETCH_ALL_PARAMS } from 'constants/query';
import { useMemo, useState } from 'react';
import { configureTableColumns } from 'utils/table-helpers';
import { useWorkspace } from 'hooks/useWorkspace';
import { useGetPlacesQuery } from 'features/place/services';
import { PromotionColumns, usePromotionTableColumns } from '../constants/table-settings';
import { useNavigate, useParams } from 'react-router-dom';
import { setWorkspace } from 'store/workspace-slice';
import { useAppDispatch } from 'app/hooks';
import { useFilterSelectOptions } from '../constants/lifecycle-status';
import useTable from 'hooks/useTable';

const useController = () => {
    const { placeId = '' } = useParams();
    const [activePlace, setActivePlace] = useState<string>(placeId);
    const { websiteId } = useWorkspace();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { data: places } = useGetPlacesQuery({
        ...FETCH_ALL_PARAMS,
        website_id: websiteId,
    });
    const FILTER_SELECT_LIFECYCLE_STATUS = useFilterSelectOptions();

    const filterSelectOptions = useMemo(() => {
        return {
            lifecycleStatus: FILTER_SELECT_LIFECYCLE_STATUS,
        };
    }, [FILTER_SELECT_LIFECYCLE_STATUS]);

    const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
        setActivePlace(newValue);
        navigate(`../promotions/${newValue}`);
    };

    const handleAddPromotion = () => {
        dispatch(setWorkspace({ placeId }));
        navigate('add/promotion');
    };

    const { tableSettings } = useTable<PromotionColumns>({
        columns: configureTableColumns(usePromotionTableColumns(), filterSelectOptions || {}),
        queryIdentifier: 'promotions',
        renderAddButton: false,
    });

    return {
        tableSettings,
        websiteId,
        places,
        placeId,
        activePlace,
        handleTabChange,
        handleAddPromotion,
    };
};

export default useController;
